import * as React from 'react';
import { ErrorMessage as BaseErrorMessage } from '@hookform/error-message';
import { Text } from '@front10/base-elements';

export function ErrorMessage(props: React.ComponentPropsWithoutRef<typeof BaseErrorMessage>) {
  return (
    <BaseErrorMessage name={props.name} as={Text} variant="errorMessage" role="alert" {...props} />
  );
}
